import React, { useContext, useEffect, useState } from "react";
import TPCheckbox from "./TPCheckbox";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from "../../redux/slices/treeSlice";

const OverrideInboundDelimeter = () => {

  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const [overrideInboundDelemiter, setOverrideInboundDelemiter] =useState(false);
  const dispatch = useDispatch();

  useEffect(()=>{
    const header = rightTree.tree.templateHeader;
    setOverrideInboundDelemiter(
      header.OVERRIDE_WITH_INBOUND_DEL
        ? (typeof header.OVERRIDE_WITH_INBOUND_DEL === "boolean" &&
            header.OVERRIDE_WITH_INBOUND_DEL) ||
            header.OVERRIDE_WITH_INBOUND_DEL === "TRUE" ||
            false
        : false
    );
  },[rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(
      treeActions.setRightTreeTemplateHeaders({
        screen: parentScreen,
        key,
        value,
      })
    );
  };
  
  return (  
    rightTree.tree.templateHeader?.FILETYPE !== "JSON" ? <TPCheckbox
      label={t("BTN_USE_INBOUND_DELIMITERS")}
      checked={overrideInboundDelemiter}
      handleCheck={(checked) => {
        setOverrideInboundDelemiter(checked);
        handleChange("OVERRIDE_WITH_INBOUND_DEL", checked ? "TRUE" : "FALSE");
      }}
    /> : ""
  );
};

export default OverrideInboundDelimeter;
